import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import FullScreenLoading from '~/components/FullScreenLoadingSpinner'
import useToast from '~/hooks/toast'
import { useUserStore } from '~/stores/userStore'
import httpClient from '~/utils/httpClient'

const LogoutPage = () => {
  const initiated = useRef(false)
  const toast = useToast()
  const navigate = useNavigate()
  const userStore = useUserStore()

  useEffect(() => {
    if (initiated.current || !toast?.current?.show) return
    initiated.current = true

    httpClient
      .get('/api/auth/logout')
      .catch(() => {})
      .finally(() => {
        userStore.logout()
        navigate('/auth/login')
        toast?.current?.show({
          summary: "You've been logged out",
          severity: 'info',
        })
      })
  }, [toast, navigate, userStore.logout])
  return <FullScreenLoading message='Logging you out...' />
}

export default LogoutPage
